import { includes } from "lodash"

import { UserStorage } from "utils/userStorage"

/************************************
 * ACTION TYPE
 ************************************/
const REDUX_SETTING_COLOR = "REDUX_SETTING_COLOR"

/************************************
 * TYPES
 ************************************/
type SettingType = {
  type: "REDUX_SETTING_COLOR"
  color: string
}

/************************************
 * ACTIONS
 ************************************/
type ChangeColorType = () => SettingType
export const changeColor: ChangeColorType = () => {
  const htmlClass = document.querySelector("html").classList
  const addColor = includes(htmlClass, "dark") ? "bright" : "dark"
  const removeColor = !includes(htmlClass, "dark") ? "bright" : "dark"
  htmlClass.add(addColor)
  htmlClass.remove(removeColor)
  UserStorage.ThemeColor.set(addColor)
  return {
    type: REDUX_SETTING_COLOR,
    color: addColor,
  }
}

/************************************
 * Reducer
 ************************************/
const initialState = {
  color: UserStorage.ThemeColor.get(),
}

export default (state = initialState, action: SettingType) => {
  switch (action.type) {
    case REDUX_SETTING_COLOR:
      return {
        color: action.color,
      }
    default:
      return state
  }
}
